import React, { Fragment, FunctionComponent, useEffect } from 'react';
import styles from './TcmTelephonicCaseManagement.Styles';
import { Grid } from '@material-ui/core';
import { EmptyDataLabel } from '../../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import TcmTelephonicCaseManagementEntity from '../../../../../../entities/tcm/TcmTelephonicCaseManagement.Entity';
import { TooltipTextField } from '../../../../../generic-components/tooltip-textfield/TooltipTextField.Component';

interface ITcmTelephonicCaseManagementProps {
    referralId: number;
    tcmTelephonicCaseManagement?: TcmTelephonicCaseManagementEntity;
    handleTcmTelephonicCaseManagementEdit: (tcm: TcmTelephonicCaseManagementEntity) => void;
}

export const TcmTelephonicCaseManagement: FunctionComponent<ITcmTelephonicCaseManagementProps> = (
    props: ITcmTelephonicCaseManagementProps
) => {
    const classes = styles();

    const [tcmState, setTcmState] = React.useState<TcmTelephonicCaseManagementEntity>(
        props.tcmTelephonicCaseManagement || { referralId: props.referralId }
    );

    useEffect(() => {
        if (props.tcmTelephonicCaseManagement) {
            setTcmState(props.tcmTelephonicCaseManagement);
        }
    }, [props.tcmTelephonicCaseManagement]);

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let newTcm: TcmTelephonicCaseManagementEntity = { ...tcmState };
        if (!newTcm.referralId) {
            newTcm.referralId = props.referralId;
        }

        newTcm[event.target.id || event.target.name] = event.target.value;

        setTcmState(newTcm);
        props.handleTcmTelephonicCaseManagementEdit(newTcm);
    };

    return (
        <Fragment>
            {tcmState ? (
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <TooltipTextField
                            label="Referral Instructions"
                            id="referralInstructions"
                            name='referralInstructions'
                            value={tcmState?.referralInstructions || ''}
                            multiline={true}
                            maxRows={4}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 2000 }}
                            helperText={`${tcmState?.referralInstructions ? tcmState.referralInstructions.length : 0}/${2000}`}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TooltipTextField
                            maxRows={4}
                            multiline={true}
                            label="Comments"
                            id="comments"
                            value={tcmState?.comments || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 800 }}
                            helperText={`${tcmState?.comments ? tcmState.comments.length : 0}/${800}`}
                        />
                    </Grid>
                </Grid>
            ) : (
                <EmptyDataLabel />
            )}
        </Fragment>
    );
};

